<template>
    <!-- 一级菜单 -->
    <div>
      <div v-for="item in menuList" :key="item.name" v-if="!item.hidden">
        <a
          :class="{ 'first-menu': firstMenuNameCurrent !== item.name, 'first-menu-selected': firstMenuNameCurrent === item.name ,'first-menu-onmouseover':firstMenuNameCurrent !== item.name && firstMenuNameCurrentOnmouseOver === item.name}"
          @click="selectedMenu(item)" style="cursor: pointer;"
          @mousemove="mousemoveMethod(item,1)"
          @mouseout="mouseoutMethod(item)">
          <div class="menu-img-border">
            <img :src="item.icon" class="menu-img">
            <div :class="{ 'menu-first': firstMenuNameCurrent !== item.name, 'menu-first-selected': firstMenuNameCurrent === item.name,'menu-first-selected-mousemove':firstMenuNameCurrent !== item.name && firstMenuNameCurrentOnmouseOver === item.name}">{{ item.name }}</div>
          </div>
          <i v-if="item.childrenList && item.childrenList.length>0 && firstMenuNameCurrent !== item.name" class="el-icon-arrow-right"></i>
          <i v-if="item.childrenList && item.childrenList.length>0 && firstMenuNameCurrent === item.name" class="el-icon-arrow-down"></i>
        </a>
        <!-- 二级菜单 -->
        <div v-if="firstMenuNameCurrent  === item.name">
          <div v-for="secondMenu in item.childrenList" :key="secondMenu.key" :class="{
                'second-menu-border': secondMenu.name !== checkedMenuCurrent,
                'second-menu-border-selected': secondMenu.name === checkedMenuCurrent,
                'second-menu-border-mousemove': secondMenu.name !== checkedMenuCurrent && secondMenuNameCurrentOnmouseOver === secondMenu.name,
              }"
              @click="gotoRouter(2, secondMenu)"
              @mousemove="mousemoveMethod(secondMenu,2)"
              @mouseout="mouseoutMethod(secondMenu)">
            <a
              :class="{
                'second-menu': secondMenu.name !== checkedMenuCurrent,
                'second-menu-selected': secondMenu.name === checkedMenuCurrent,
                'second-menu-mousemove': secondMenu.name !== checkedMenuCurrent && secondMenu.name === secondMenuNameCurrentOnmouseOver
              }"
            >
              {{ secondMenu.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    // 选中的菜单，用来加粗加下划线显示
    checkedMenu: {
      type: String,
      default: ''
    },
    // 选中的一级菜单，选中则显示对应2级菜单
    firstMenuName: {
      type: String,
      default: ''
    },
    menuList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    checkedMenu(n, o) {
      this.checkedMenuCurrent = n
    },
    firstMenuName(n, o) {
      this.firstMenuNameCurrent = n
    }

  },
  data() {
    return {
      firstMenuNameCurrentOnmouseOver: '',
      secondMenuNameCurrentOnmouseOver: '',
      checkedMenuCurrent: '',
      firstMenuNameCurrent: '',
      feNetWork: ''
    }
  },
  created() {
    this.feNetWork = this.getEnvUrl()
  },
  methods: {
    /**
     * 菜单移入效果
     */
    mousemoveMethod(item, level) {
      if (level === 1) {
        this.firstMenuNameCurrentOnmouseOver = item.name
      } else {
        this.secondMenuNameCurrentOnmouseOver = item.name
      }
    },
    /**
     * 菜单移出效果
     */
    mouseoutMethod(item) {
      this.firstMenuNameCurrentOnmouseOver = ''
      this.secondMenuNameCurrentOnmouseOver = ''
    },
    /**
     * 选中菜单只负责显示下级菜单
     */
    selectedMenu(item) {
      // 首先判断他有没有子级，如果有且打开的不是当前父级菜单则打开并选择子集第一个
      if (item.childrenList && item.childrenList.length > 0) {
        if (this.firstMenuNameCurrent !== item.name) {
          const child = item.childrenList[0]
          this.checkedMenuCurrent = child.name
          this.gotoRouter(2, child)
        }
      } else {
        if (item.name !== 'Help Center') {
          this.checkedMenuCurrent = item.name
          this.firstMenuNameCurrent = item.name
        }
        // 如果没有，则需要判断跳转到平台还是跳转到外部
        if (item.type === 'out') {
          window.open(item.path)
        } else if (item.type === 'platform') {
          window.location.href = this.feNetWork + this.$tokenUrl(item.path, item.status)
        } else if (item.type === 'in') {
          this.$router.push({path: item.path + '/' + item.key})
        }
      }
    },
    /**
     * 点击二级菜单存在跳转,并且将选中的name进行更新
     */
    gotoRouter(num, item) {
      this.checkedMenuCurrent = item.name
      // 然后跳转，目前其他的菜单都跳转到平台
      if (item.type === 'in') {
        this.$router.push({name: 'menu', params: {key: item.key}})
      } else if (item.type === 'platform') {
        window.location.href = this.feNetWork + this.$tokenUrl(item.path, item.status)
      }
    },
    getEnvUrl(type) {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://test-thalesmart-manage-ui2.hupofintech.com'
            : 'https://test-thalesmart-manage-ui.hupofintech.com'
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url =
          type === 'feCartWork'
            ? 'http://localhost:8080'
            : 'http://localhost:3000'
        return url
      }
      if (href.indexOf('pre') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://pre.shopvidi.com'
            : 'https://p.shopvidi.com'
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url =
          type === 'feCartWork'
            ? 'https://shopvidi.com'
            : 'https://p.shopvidi.com'
        return url
      }
      if (href.indexOf('192') >= 0) {
        url =
          type === 'feCartWork'
            ? 'http://192.168.3.54:8080'
            : 'http://192.168.3.54:3000'
        return url
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-divider--horizontal{
  width:100% !important;
  margin: 10px 0px !important;
}
.el-icon-arrow-down{
  color:#AAA6A6
}
.el-icon-arrow-right{
  color:#AAA6A6
}
.menu-img-border {
  height: 50px;
  display: flex;
  align-items: center
}

.menu-img {
  height: 25px;
  width: 25px;
  margin-left: 20px;
}

.menu-border {
  height: calc(100vh - 90px);
  width: 100%;
  padding: 30px 10px 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.menu-first {
  margin-left: 20px;
  font-family: Satoshi-Regular;
}
.menu-first-selected {
  margin-left: 20px;
  font-family: Satoshi-Medium !important;
}
.menu-first-selected-mousemove {
  margin-left: 20px;
  font-family: Satoshi-Medium !important;
}

.first-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #262626;
  font-size: 14px;
  font-family: Satoshi-Regular;
  height: 50px;
  line-height: 50px;
  padding-right: 10px;
}

.first-menu-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #262626;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  line-height: 50px;
  background-color: #F3E93D;
  border-radius: 3px;
  margin-bottom: 10px;
  padding-right: 10px;
}
.first-menu-onmouseover{
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #262626;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  line-height: 50px;
  background-color: #EDEDED;
  border-radius: 3px;
  padding-right: 10px;
}

.second-menu {
  color: #262626;
  font-size: 14px;
  font-family: Satoshi-Regular;
  line-height: 36px;
  color: #262b2f;
  padding-left: 16px;
}

.second-menu-selected {
  color: #262626;
  font-size: 14px;
  line-height: 36px;
  padding-left: 16px;
  font-family: Satoshi-Medium !important;
}
.second-menu-mousemove{
  color: #262626;
  font-size: 14px;
  line-height: 36px;
  padding-left: 16px;
  font-family: Satoshi-Medium !important;
}

.second-menu-border {
  margin-left: 48px;
  cursor: pointer;
  border-left: black 1px solid;
}
.second-menu-border-mousemove{
  margin-left: 48px;
  cursor: pointer;
  border-left: #F3E93D 1px solid;
}
.second-menu-border-selected {
  margin-left: 48px;
  cursor: pointer;
  border-left: #F3E93D 1px solid;
}

.el-divider--horizontal {
  width: 100px;
  margin: 0px 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/components/vidi-menu.vue